import { mergeStyleSets } from '@fluentui/react'
import * as React from 'react'
import { ReactElement, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { IFileDto } from '../../../config/fileConfig'
import CommandButtons, { CommandButtonProps } from '../../Form/CommandButtons'
import CommandDialog, { Dismiss } from '../Command/CommandDialog'
import FileDropdown from '../../Dropdown/File/FileDropdown'
import FileHeader from '../../Render/FileHeader'
import useEntity from '../../../hooks/useEntity'

const classNames = mergeStyleSets({ fileHeader: { marginTop: '1em' } })

export default function SearchFileDialog(): ReactElement {
    const history = useHistory()
    const [id, setId] = useState<string>()
    const [file] = useEntity<IFileDto>(id => ({ url: `/file/${id}` }), id)

    const primaryButtonProps: CommandButtonProps = id && {
        text: 'Dossier openen',
        onClick: (dismiss: Dismiss) => {
            dismiss()
            history.push(`/file/${id}`)
        },
    }

    return (
        <CommandDialog dialogContentProps={{ title: 'Dossier zoeken' }}>
            {({ onDismiss }: { onDismiss: Dismiss }) => (
                <>
                    <FileDropdown autoFocus setSelectedKey={option => setId(option.key as string)} selectedKey={id} />
                    {(file.loaded || file.loading) && (
                        <FileHeader
                            className={classNames.fileHeader}
                            file={file.data}
                            showDescription
                            showTitle={false}
                        />
                    )}
                    <CommandButtons dismiss={onDismiss} dismissButton primaryButtonProps={primaryButtonProps} />
                </>
            )}
        </CommandDialog>
    )
}
